import React from "react";
import reactStringReplace from "react-string-replace";
import { Icd10Code } from "../../../../messages/IcdCode";
import SearchModalResult from "../../../SearchModal/SearchModalResult/SearchModalResult";

interface Props {
  icdCode: Icd10Code;
  searchValue: string;
  onClick: () => void;
}

const SearchICDCardResult = ({ icdCode, searchValue, onClick }: Props) => {
  const markedText = React.useMemo(
    () =>
      reactStringReplace(icdCode.shortDesc, searchValue, (match, i) => (
        <mark key={i}>{match}</mark>
      )),
    [icdCode, searchValue]
  );

  return (
    <SearchModalResult label={markedText} metadata={[icdCode.formattedDxCode]} onClick={onClick} />
  );
};

export default React.memo(SearchICDCardResult);
